<p class="mb-3">
  Mapeados e reports ficam Apta ou Não Apta, com o motivo. Efetuados são as capturas
  dos últimos 30 dias que ainda carregam a suspeita de fraude. A tela só consulta.
</p>

<p-tabView>
  <p-tabPanel header="Reprocessamentos Mapeados">
    <app-table
      [lazy]="true"
      [cols]="mappedColumns"
      tableTitle="Reprocessamentos Mapeados"
      [addButton]="false"
      [exportPdf]="false"
      [exportExcel]="false"
      [refreshButton]="true"
      [service]="reportService"
      pageFunctionName="getMappedReprocess"
      emptyMessage="Nenhuma tentativa recente para analisar."
      modelName="Registros"
      [defaultRows]="15"
      sortField="dateCreated"
      [sortOrder]="1"
    ></app-table>
  </p-tabPanel>

  <p-tabPanel header="Reprocessamento Efetuados">
    <app-table
      [lazy]="true"
      [cols]="completedColumns"
      tableTitle="Reprocessamento Efetuados"
      [addButton]="false"
      [exportPdf]="false"
      [exportExcel]="false"
      [refreshButton]="true"
      [service]="reportService"
      pageFunctionName="getCompletedReprocess"
      emptyMessage="Nenhuma captura recente depois de suspeita de fraude."
      modelName="Registros"
      [defaultRows]="15"
      sortField="dateAuthorized"
      [sortOrder]="1"
    ></app-table>
  </p-tabPanel>

  <p-tabPanel header="Como funciona">
    <div class="p-3" style="max-width: 52rem; line-height: 1.5">
      <p>
        A situação e o motivo saem de uma regra fixa no admin-api. Não há chamada de
        modelo de IA nesta tela. A regra replica a mecânica usada na análise: a primeira
        condição que falha vira o motivo de Não Apta.
      </p>
      <p>A tela só consulta. Nenhuma aba captura pagamento.</p>

      <h3>Reprocessamentos Mapeados</h3>
      <p>
        Entram pessoas com pagamento Pagar.me (gateway 31), autorização recusada e extra
        “Suspeita de fraude - Gateway” ou “Transação aprovada com sucesso”, nos últimos 4
        dias, ainda sem captura. A classificação usa a última tentativa dessa janela.
      </p>
      <p>Nesta ordem, Não Apta quando:</p>
      <ol>
        <li>Não há tentativa para analisar.</li>
        <li>A última tentativa está fora dos 4 dias.</li>
        <li>O gateway não é o do reprocessamento.</li>
        <li>A última tentativa já foi capturada (status 6).</li>
        <li>A autorização não é “Autorização recusada” ou o extra não é um dos dois acima.</li>
        <li>A assinatura está no status 0, 2 ou 10.</li>
        <li>A pessoa está no status 15.</li>
        <li>A pessoa é BFLU (influencer ativo).</li>
        <li>Há cancelamento por fraude ou chargeback (motivos 28 ou 61).</li>
        <li>O CEP ou o telefone pertence a alguém no status 15.</li>
      </ol>
      <p>
        Reativação, renovação e retenção que passam nessa lista ficam Apta. O motivo diz
        que o último retorno é suspeita de fraude no gateway, sem análise extra.
      </p>
      <p>Aquisição continua. Fica Não Apta se:</p>
      <ol>
        <li>Houve mais de um cartão na janela.</li>
        <li>O cartão da tentativa não é o cartão da assinatura.</li>
        <li>No Elo, o primeiro nome do cadastro não aparece no titular.</li>
        <li>O cartão não tem titular, ou o titular não contém o primeiro nem o último nome (mínimo de 3 letras).</li>
        <li>O e-mail local tem 6 dígitos seguidos, metade ou mais em dígitos, ou 12 letras sem vogal.</li>
      </ol>
      <p>Se tudo passa, a aquisição fica Apta. Frete e outros tipos ficam Não Apta.</p>

      <h3>Report bflus</h3>
      <p>
        Cada report gravado é classificado pelo e-mail da glamgirl, com a mesma ordem.
        Sem cadastro, o motivo é “E-mail não encontrado no cadastro.” Pagamento antigo
        fica fora da janela de 4 dias.
      </p>

      <h3>Reprocessamento Efetuados</h3>
      <p>
        Não repassa pela regra de Apta. Lista capturas dos últimos 30 dias no gateway 31,
        status 6, cujo extra ainda é “Suspeita de fraude - Gateway”. A situação é Efetuado.
      </p>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Report bflus">
    <app-table
      [lazy]="true"
      [cols]="reportColumns"
      tableTitle="Report bflus"
      [addButton]="false"
      [exportPdf]="false"
      [exportExcel]="false"
      [refreshButton]="true"
      [service]="reportService"
      pageFunctionName="getBfluGlamgirlSignupReports"
      emptyMessage="Nenhum report de BFLU ainda."
      modelName="Reports"
      [defaultRows]="15"
      sortField="dateCreated"
      [sortOrder]="1"
    ></app-table>
  </p-tabPanel>
</p-tabView>
